import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ShieldAlert } from "lucide-react";

import { Alert, AlertDescription, AlertTitle } from "~/components/ui/alert";
import { Skeleton } from "~/components/ui/skeleton";
import { useEmployeePermissions } from "~/hooks/use-employee-permissions";

import { EndOfDaySelect } from "../../../../components/end-of-day/end-of-day-select";

export const Route = createFileRoute(
  "/_authenticated/locations/$id/end-of-day"
)({
  component: EndOfDaySettingsLayout,
});

function EndOfDaySettingsLayout() {
  const { hasPermission, isLoading, hasEmployee } = useEmployeePermissions();
  const canViewIntegrations = hasPermission("viewIntegrations");

  // Loading state
  if (isLoading) {
    return <Skeleton className="h-96 w-full" />;
  }

  // No employee record linked
  if (!hasEmployee) {
    return (
      <Alert>
        <ShieldAlert className="h-4 w-4" />
        <AlertTitle>No Employee Profile</AlertTitle>
        <AlertDescription>
          Your account is not linked to an employee profile. Contact your
          organization admin to set up your employee record with the appropriate
          permissions.
        </AlertDescription>
      </Alert>
    );
  }

  // No permission to view end-of-day settings
  if (!canViewIntegrations) {
    return (
      <Alert variant="destructive">
        <ShieldAlert className="h-4 w-4" />
        <AlertTitle>Access Denied</AlertTitle>
        <AlertDescription>
          You don't have permission to view end of day settings. Contact your
          manager to request access.
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap justify-between gap-6">
        <div className="space-y-1">
          <h2 className="body text-foreground text-weight-medium text-balance">
            Configure End of Day Reports
          </h2>
          <p className="body-sm text-muted-foreground">
            Customize printed reports for your employees and business.
          </p>
        </div>
        <EndOfDaySelect />
      </div>
      <Outlet />
    </div>
  );
}
